/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { MembershipTypesEnumType } from './MembershipTypesEnum'
import { RootStoreType } from './index'

/**
 * MembershipTypeBase
 * auto generated base class for the model MembershipTypeModel.
 */
export const MembershipTypeModelBase = ModelBase.named('MembershipType')
  .props({
    __typename: types.optional(types.literal('MembershipType'), 'MembershipType'),
    active: types.union(types.undefined, types.boolean),
    description: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    price: types.union(types.undefined, types.number),
    stripePriceId: types.union(types.undefined, types.string),
    stripeProductId: types.union(types.undefined, types.string),
    type: types.union(types.undefined, MembershipTypesEnumType)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class MembershipTypeModelSelector extends QueryBuilder {
  get active() {
    return this.__attr('active')
  }
  get description() {
    return this.__attr('description')
  }
  get name() {
    return this.__attr('name')
  }
  get price() {
    return this.__attr('price')
  }
  get stripePriceId() {
    return this.__attr('stripePriceId')
  }
  get stripeProductId() {
    return this.__attr('stripeProductId')
  }
  get type() {
    return this.__attr('type')
  }
}
export function selectFromMembershipType() {
  return new MembershipTypeModelSelector()
}

export const membershipTypeModelPrimitives =
  selectFromMembershipType().active.description.name.price.stripePriceId.stripeProductId.type
